import { FC } from 'react';
import { Navigate } from 'react-router';
import { SpotLoading } from '@enterprise/spot';

interface Props {
    to: string;
}

const RedirectToRouteComponent: FC<Props> = ({ to }) => (
    <>
        <SpotLoading text="Redirecting..." />
        <Navigate to={to} replace />
    </>
);

export default RedirectToRouteComponent;
